import React from 'react';
import { Alert } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export default function CompanySuspendedBanner() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Layout:CompanySuspendedBanner' });

  const { serviceProvider } = useSelector((state) => state.currentServiceProvider);

  return (
    <Alert
      banner
      title={
        <Trans
          t={t}
          values={{ supportEmail: serviceProvider?.support_email }}
          components={{ a: <a href={`mailto:${serviceProvider?.support_email}`} /> }}
        >
          text
        </Trans>
      }
    />
  );
}
